import { prop } from 'datx';
import { OptionValue } from './OptionValue';

import { BaseModel } from './BaseModel';

export class Picker extends BaseModel {
  public static type = 'picker';

  @prop
  public uid!: string;

  @prop
  public type!: string;

  @prop
  public isSelected!: boolean;

  @prop.toMany(OptionValue)
  public optionValues!: Array<OptionValue>;
}
